export default {
  date_range_overlap: 'Fund end date cannot must be after start date',
  cap_overlap: 'Hard cap must be higher than soft cap',
  failed: 'Failed to create fund',
  success: 'Fund creation is completed. Please wait for administrator\'s approval',
  succeded_but_not_loaded: 'Your request was succeeded, but something went wrong while loading additional information. ' +
  'Please reload the page, or try again later, if this didn\'t help',
  failed_to_create_token: 'Failed to create token',
  failed_to_update_sale: 'Failed to update fund info',
  assets_not_unique: 'Duplication not allowed',
  no_quote_asset: 'Need at least one asset',
  low_preissuance: 'Amount must be not less than 1'
}



// WEBPACK FOOTER //
// ./src/js/i18n/to_replace/sales.js